import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { INativeStorageService } from '@boxx/core';
import { Preferences } from '@capacitor/preferences';

@Injectable()
export class LocalStorageNativeService implements INativeStorageService {

  constructor(private plt: Platform) {
    //this.storage = this.plt.is('cordova' || 'capacitor') ? stg : localStorage;
  }

  getItem(_key: string): Promise<string> {
    return new Promise((resolve, reject) => {

      Preferences.get({ key: _key }).then(
        (data) => {
          const response = data.value;
          return resolve(response)
        },
        (e) => {
          if (e.code && e.code === 2) {
            // Key is not present in storage
            return resolve(null);
          } else {
            console.error(
              `REJECT: ERROR while trying to get key ${_key} from localstore`
            );
            reject(e);
          }
        }
      )
      .catch((e) => {
        if (e.code && e.code === 2) {
          // Key is not present in storage
          resolve(null);
        } else {
          console.error(
            `CATCH: ERROR while trying to get key ${_key} from localstore`
          );
          reject(e);
        }
      });

      // if (this.plt.is('cordova' || 'capacitor')) {
      //   (this.storage as NativeStorage)
      //     .getItem(key)
      //     .then(
      //       (val) => resolve(val),
      //       (e) => {
      //         if (e.code && e.code === 2) {
      //           // Key is not present in storage
      //           resolve(null);
      //         } else {
      //           console.error(
      //             `REJECT: ERROR while trying to get key ${key} from localstore`
      //           );
      //           reject(e);
      //         }
      //       }
      //     )
      //     .catch((e) => {
      //       if (e.code && e.code === 2) {
      //         // Key is not present in storage
      //         resolve(null);
      //       } else {
      //         console.error(
      //           `CATCH: ERROR while trying to get key ${key} from localstore`
      //         );
      //         reject(e);
      //       }
      //     });
      // } else {
      //   resolve(this.storage.getItem(key));
      // }
    });
  }

  setItem(_key: string, _value: any): Promise<any> {
    return Promise.resolve(
      Preferences.set({
        key: _key,
        value: _value
      })
    );
  }

  removeItem(_key: string): Promise<any> {
    Preferences.remove({ key: _key }).then(
      ()=>{ return Promise.resolve(true)}
    );
    return Promise.resolve(true);
    // return 1;

    // return this.plt.is('cordova' || 'capacitor')
    //   ? (this.storage as NativeStorage).remove(key)
    //   : Promise.resolve(this.storage.removeItem(key));
  }

  keys(): Promise<Array<string>> {
    if (this.plt.is('cordova' || 'capacitor')) {
      //return this.stg.keys();
      return null;
    }

    const keys: Array<string> = [];

    for (let i = 0; i < localStorage.length; i++) {
      keys.push(localStorage.key(i));
    }

    return Promise.resolve(keys);
  }

  clearStorage(): Promise<any> {
    return Promise.resolve(Preferences.clear());
  }
}
